import React, { useEffect, useState } from 'react'
import Swal from 'sweetalert2';
import {
  collection,
  deleteDoc,
  doc,
  getDoc,
  getDocs,
  onSnapshot,
  orderBy,
  query,
  updateDoc,
  where,
} from 'firebase/firestore';
import { auth, db } from '../firebase';
import { TextField, TablePagination } from '@mui/material';
import moment from 'moment';

export default function Viewjavakdata() {
  const Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    didOpen: (toast) => {
      toast.addEventListener('mouseenter', Swal.stopTimer)
      toast.addEventListener('mouseleave', Swal.resumeTimer)
    }
  });

  const [userData, setUserData] = useState();
  const [loadincount, setloadincount] = useState(true);

  const [javakdatas, setjavakdatas] = useState([]);
  const [searchText, setsearchText] = useState("");

  const [updocid, setupdocid] = useState("");

  const [javakdate, setjavakdate] = useState(moment().format('YYYY-MM-DD'));
  const [javakpersonname, setjavakpersonname] = useState(" ");
  const [javaknote, setjavaknote] = useState(" ");

  // pagination
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  useEffect(() => {
    auth.onAuthStateChanged((user) => {
      setUserData(user);
      fetchPropid()
    });
  });

  const fetchPropid = async () => {
    if (userData) {
      if (loadincount) {
        const docRef = doc(db, "users", userData.uid)
        const docSnap = await getDoc(docRef)
        if (docSnap.exists()) {
          fetchData1();
          setloadincount(false)
        }
      }
    }
  }

  const fetchData1 = async () => {
    try {
      const q = query(collection(db, 'javakregisters'), orderBy('javakdate', 'desc'))
      onSnapshot(q, (querySnapshot) => {
        setjavakdatas(querySnapshot.docs.map(doc => ({
          id: doc.id,
          data: doc.data()
        })));
      });
    } catch (error) {
      Toast.fire({
        icon: "error",
        title: error.message
      });
    }
  }

  const handleDelete = async (docid) => {
    try {
      const javakItemsQuery = query(collection(db, 'javakitems'), where("javakid", "==", docid));
      const javakItemsSnapshot = await getDocs(javakItemsQuery);

      const deletePromises = javakItemsSnapshot.docs.map((doc) => deleteDoc(doc.ref));
      await Promise.all(deletePromises);

      const taskDocRef = doc(db, 'javakregisters', docid);
      await deleteDoc(taskDocRef);

      Toast.fire({
        icon: "success",
        title: 'Javak Data and Related Items Deleted Successfully!!'
      });

      fetchData1();
    } catch (error) {
      Toast.fire({
        icon: "error",
        title: 'Error deleting data. Please try again!'
      });
      console.error("Error deleting data:", error);
    }
  };

  const handleEdit = (id, javakdate, javakpersonname, javaknote) => {
    setupdocid(id);
    setjavakdate(javakdate)
    setjavakpersonname(javakpersonname)
    setjavaknote(javaknote)
  }

  const handleUpdate = async () => {
    await updateDoc(doc(db, "javakregisters", updocid), {
      javakdate: javakdate,
      javaknote: javaknote,
      javakpersonname: javakpersonname,
    });
    Toast.fire({
      icon: "success",
      title: 'Javak Data Updated Successfully!!'
    });

    fetchData1();
  }

  // filter data with search
  const filteredData = javakdatas.filter((item) =>
    item.data.javakpersonname.toUpperCase().includes(searchText.toUpperCase())
  );

  // pagination handlers
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  return (
    <div>
      <div className="content-wrapper">
        <br />

        <section className="content">
          <div className="container-fluid">
            <button className="btn btn-secondary " style={{ float: "right", textTransform: "uppercase" }} >|| View Javak Data ||</button><br /><br /><br />
            <div className="card card-primary card-outline ex1">
              <div className=" p-1">
                <input type="search" value={searchText} onChange={(e) => setsearchText(e.target.value)}
                  className='form-control col-sm-4' placeholder='Type here......' />
              </div>
              <div className="card-body table-responsive p-0" >

                <table className="table table-bordered table-hover table-striped table-head-fixed">
                  <thead>
                    <tr>
                      <th>Action</th>
                      <th>Sr No</th>
                      <th>Javak Date </th>
                      <th>Person Name </th>
                      <th>Note </th>
                      {/* <th>Items </th> */}
                    </tr>
                  </thead>
                  <tbody>
                    {filteredData
                      .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                      .map((item, index) =>
                        <tr key={item.id}>
                          <td>
                            <a onClick={() => handleEdit(item.id, item.data.javakdate, item.data.javakpersonname, item.data.javaknote)} href='#0' data-toggle="modal" data-target="#text-modal1" className="btn btn-sm btn-success" > <i className="fa fa-edit"></i></a>&nbsp;
                            <a onClick={() => { if (window.confirm('Are u sure?')) { handleDelete(item.id) }; }} className="btn btn-sm btn-danger" href='#0' > <i className="fa fa-trash"></i></a>&nbsp;
                            <a className="btn btn-sm bg-purple" href={'javak-details/' + item.id} > <i className="fa fa-eye"></i></a>
                          </td>
                          <td width="80">{page * rowsPerPage + index + 1}</td>
                          <td>{moment(item.data.javakdate).format('DD-MM-YYYY')}</td>
                          <td>{item.data.javakpersonname}</td>
                          <td>{item.data.javaknote}</td>
                          {/* <td>
                            {item.data.javakitems.map((item1, i) =>
                              <span key={i}> # {item1.product} ({item1.quantity} Qty) <br /></span>
                            )}
                          </td> */}
                        </tr>
                      )}
                  </tbody>
                </table>

                {/* pagination control */}
                <TablePagination
                  component="div"
                  count={filteredData.length}
                  page={page}
                  onPageChange={handleChangePage}
                  rowsPerPage={rowsPerPage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                  rowsPerPageOptions={[5, 10, 25, 50]}
                />

              </div>
            </div>
          </div>
        </section>
      </div>

      {/* ============================================= modal start ================================================= */}

      <div className="modal fade" id="text-modal1">
        <div className="modal-dialog modal-xl">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">Edit Javak Data</h4>
              <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span></button>
            </div>
            <div className="modal-body">
              <div className='card'>
                <div className="card-body">
                  <div className='row'>
                    <div className='col-sm-4'>
                      <TextField className='form-control' color="secondary" label="javak Date" type='date' value={javakdate} onChange={(e) => setjavakdate(e.target.value)} size='small' /> <br /><br />
                    </div>
                    <div className='col-sm-4'>
                      <TextField type='text' className='form-control' value={javakpersonname} onChange={(e) => setjavakpersonname(e.target.value)} label="javak Person Name" size='small' /><br /><br />
                    </div>
                    <div className='col-sm-4'>
                      <TextField type='text' className='form-control' value={javaknote} onChange={(e) => setjavaknote(e.target.value)} label="Bill Note 1" /><br /><br />
                    </div>
                  </div>
                </div>
                <div className="modal-footer justify-content-between">
                  <button type="button" onClick={() => handleUpdate()} className="btn btn-primary" data-dismiss="modal">Update </button>
                  <button type="button" className="btn btn-danger" data-dismiss="modal">Close</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
